const TOURNAMENT_STATUS = {
  maybego: 1,
  maybeend: 2,
};

const DEFAULT_NAMES = {
  tournament: 'Турнир',
  stage: 'Раунд',
  group: 'Группа',
};

const MIN_STAGES_LENGTH_BY_HAS_TOURNAMENT_STAGES = {
  [true]: 2,
  [false]: 1,
};

export default {
  TOURNAMENT_STATUS,
  DEFAULT_NAMES,
  MIN_STAGES_LENGTH_BY_HAS_TOURNAMENT_STAGES,
};
